import { Component } from 'react'
import { SimpleReadingList } from 'stylewhere/api'
import { List, StatusChip } from 'stylewhere/components'
import { T, __ } from 'stylewhere/shared/i18n'

interface Props {
  simpleReadingList: SimpleReadingList
  onClick: () => void
}

export class SimpleReadingListRow extends Component<Props> {
  getStatusBgColor(status: string) {
    switch (status) {
      case 'CREATED':
        return 'default'
      case 'STARTED':
        return 'warning'
      case 'CONFIRMED':
        return 'success'
      default:
        return 'default'
    }
  }

  showExpected = () => {
    const { simpleReadingList } = this.props
    return simpleReadingList.expected && simpleReadingList.expected !== null && simpleReadingList.expected > 0
  }

  render() {
    const { simpleReadingList, onClick, ...rest } = this.props
    const showExpected = this.showExpected()
    return (
      <List.Row mr={3} ml={3} pl={20} pr={20} pt={20} pb={20} onClick={onClick} {...rest}>
        <List.Cell maxWidth={'20%'} p={5} label={__(T.misc.code)} value={simpleReadingList.code} />
        <List.Cell flex={0} width={240} p={5} label={__(T.misc.status)}>
          <StatusChip
            status={simpleReadingList.status || '?'}
            customStatusType={this.getStatusBgColor(simpleReadingList.status ?? '')}
            pv={1}
            fontSize={16}
          />
        </List.Cell>
        <List.Cell
          flex={0}
          width={100}
          p={5}
          label={showExpected ? `${__(T.misc.read)}/${__(T.misc.expected)}` : __(T.misc.read)}
          value={
            showExpected
              ? `${simpleReadingList.detected}/${simpleReadingList.expected}`
              : `${simpleReadingList.detected}`
          }
        />
      </List.Row>
    )
  }
}
